import styled from "styled-components";

export const Nav = styled.nav`
  background: var(--primary);
  box-shadow: 0 2px 12px rgba(var(--primary-rgb), 0.3);
  position: sticky;
  top: 0;
  z-index: 100;
  width: 100%;
`;

export const Inner = styled.div`
  display: flex;
  align-items: center;
  height: 58px;
  gap: 0.5rem;
`;

export const LogoLink = styled.a`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin-right: 1.5rem;
  background: #ffffff;
  padding: 10px 22px;
  border-radius: 0 0 12px 12px;
  margin-top: -1px;
  align-self: flex-start;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  transition: box-shadow 0.2s ease, background 0.15s ease;

  img {
    height: 34px;
    width: auto;
    display: block;
  }

  &:hover {
    background: #f9fafb;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
  }

  &:focus-visible {
    outline: 2px solid rgba(0, 0, 0, 0.3);
    outline-offset: 2px;
  }
`;

export const NavList = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 0.125rem;
  flex: 1;
`;

export const NavItem = styled.li``;

export const NavLinkStyled = styled.a<{ $active?: boolean }>`
  display: inline-flex;
  align-items: center;
  padding: 0.4rem 0.75rem;
  border-radius: 2rem;
  font-size: 0.8125rem;
  font-weight: ${({ $active }) => ($active ? 700 : 600)};
  color: #ffffff !important;
  background: ${({ $active }) =>
    $active ? "rgba(255,255,255,0.18)" : "transparent"};
  text-decoration: none !important;
  transition: background 0.15s ease, color 0.15s ease;
  white-space: nowrap;
  cursor: pointer;
  letter-spacing: 0.01em;

  &:hover {
    background: rgba(255, 255, 255, 0.14);
    color: #ffffff !important;
    text-decoration: none !important;
  }

  &:focus-visible {
    outline: 2px solid rgba(255, 255, 255, 0.7);
    outline-offset: 2px;
  }
`;

export const Spacer = styled.div`
  flex: 1;
`;

export const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 0.375rem;
  flex-shrink: 0;
`;

export const Divider = styled.div`
  width: 1px;
  height: 22px;
  background: rgba(255, 255, 255, 0.2);
  margin: 0 0.25rem;
`;

/* ── Notification Bell ── */
export const BellButton = styled.button`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: none;
  background: rgba(255, 255, 255, 0.12);
  border-radius: 50%;
  color: #ffffff;
  font-size: 1.125rem;
  cursor: pointer;
  transition: background 0.15s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.22);
  }

  &:focus-visible {
    outline: 2px solid rgba(255, 255, 255, 0.7);
    outline-offset: 2px;
  }
`;

export const NotifBadge = styled.span`
  position: absolute;
  top: 2px;
  right: 2px;
  min-width: 16px;
  height: 16px;
  padding: 0 3px;
  background: #ef4444;
  color: #ffffff;
  font-size: 0.625rem;
  font-weight: 700;
  border-radius: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  border: 1.5px solid var(--primary);
`;

/* ── User Button ── */
export const UserButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.3rem 0.75rem 0.3rem 0.3rem;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 2rem;
  color: #ffffff;
  font-size: 0.8125rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease;
  max-width: 180px;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }

  &:focus-visible {
    outline: 2px solid rgba(255, 255, 255, 0.7);
    outline-offset: 2px;
  }
`;

export const Avatar = styled.span`
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.25);
  color: #ffffff;
  font-size: 0.6875rem;
  font-weight: 800;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  letter-spacing: 0;
  text-transform: uppercase;
`;

export const UserName = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 110px;
`;

export const ChevronIcon = styled.i`
  font-size: 1rem;
  opacity: 0.7;
  flex-shrink: 0;
`;

/* ── Mobile burger ── */
export const ThemeToggle = styled.button<{ $dark?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: none;
  background: rgba(255, 255, 255, 0.12);
  border-radius: 50%;
  color: #ffffff;
  font-size: 1.0625rem;
  cursor: pointer;
  transition: background 0.15s ease, transform 0.3s ease;
  flex-shrink: 0;

  &:hover {
    background: rgba(255, 255, 255, 0.22);
    transform: rotate(${({ $dark }) => ($dark ? "-20deg" : "20deg")});
  }

  &:focus-visible {
    outline: 2px solid rgba(255, 255, 255, 0.7);
    outline-offset: 2px;
  }
`;

export const BurgerButton = styled.button`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  width: 36px;
  height: 36px;
  padding: 6px;
  background: rgba(255, 255, 255, 0.12);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.15s ease;

  span {
    display: block;
    height: 2px;
    width: 100%;
    background: #ffffff;
    border-radius: 2px;
    transition: 0.2s ease;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.22);
  }

  &:focus-visible {
    outline: 2px solid rgba(255, 255, 255, 0.7);
    outline-offset: 2px;
  }
`;
